<template>
  <div class="add-c-type-number">
     <!-- 数值类型 -->
    <div class="add-c-type-number-type">
       <div class="c-panel-tabView-title">数值类型</div>
       <div class="add-c-type-number-type-radio">
          <el-radio v-model="form.valueType" label="0" :disabled="isEdit">手动输入</el-radio>
          <el-radio v-model="form.valueType" label="1" :disabled="isEdit">
            <span class="add-c-type-number-type-radio-tip_wrapper">
              <span>公式计算</span>
              <popover-tip :width = "235">
                <div class="public-tipItem">对已有字段进行公式配置，自动得出结果；</div>
                <div class="public-tipItem">例如：</div>
                <div class="public-tipItem">公式（尾款 = 合同金额 - 收入）</div>
                <div class="public-tipItem">合同金额：10900.00</div>
                <div class="public-tipItem">收入：10000.00</div>
                <div class="public-tipItem">所以该字段自动显示为</div>
                <div class="public-tipItem">尾款：900.00</div>
              </popover-tip>

              <!-- 自动计算 -->
              <transition name = "fade">
              	<div class='autoCalculation' v-if="form.valueType==='1'">
                  <el-input
                    size="mini"
                    readonly
                    @focus='shouqiAll=true'
                    v-model="form.formulaName"
                    class="add-c-type-number-type-radio-tip_wrapper-formula"
                    placeholder="请编辑公式"
                  >
                  </el-input>
              		<transition name = "fade">
              			<div class="autoCalculation_card" v-show='shouqiAll' >
              					<div class='rules'>
              						<span v-for='item in rulesList' :key='item.id' class='rules_item'
              							@click='handleRuleC(item)'
              						>
              							{{item.value}}
              						</span>
              					</div>
              					<div class='numberList'>
              						<span v-for='item in numberTypeList' :key='item.id' class='numberList_item' :style='{background:item.color}'
              						@click='handleContentClick(item)'>
              							{{item.name}}
              						</span>
              					</div>
              					<div style='text-align: right;'>
              					<el-button type='text' @click='getAllNuberType(getId)'>刷新</el-button>
              					<el-button type='text' @click='shouqiAll=false'>收起</el-button>
              					<el-button type='text' @click='deleteAll'>清空</el-button>
              				</div>
              			</div>
              		</transition>
              	</div>
              </transition>
            </span>
          </el-radio>
      </div>
     </div>
     <!-- 取数规则 -->
    <div class="add-c-type-number-rule">
      <div class="c-panel-tabView-title">取数规则</div>
      <div>
        <el-checkbox v-model="form.decimalNum_s">
          <div class="c-panel-check-labelWrapper">
            <span class="c-panel-check-labelWrapper-value">
              <span>取小数点后</span>
              <el-input size="mini" v-model="form.decimalNum" class="c-panel-check-labelWrapper-value-input"></el-input>
              <span>位</span>
            </span>
            <public-tips content="输入数字后,会自动四舍五入当前位数"></public-tips>
          </div>
        </el-checkbox>
      </div>
    </div>
    <!-- 后缀单位 -->
    <div class="add-c-type-number-unit">
      <div class="c-panel-tabView-title">后缀单位</div>
      <div>
        <el-radio v-model="form.unitType" label="1">无计量单位</el-radio>
        <el-radio v-model="form.unitType" label="2">
          <span class="add-c-type-number-unit-label">
            <span class="add-c-type-number-unit-label-title">
              <span>有计量单位</span>
              <el-input size="mini" v-model="form.unit" class="add-c-type-number-unit-label-title-input" placeholder="单位"></el-input>
            </span>
            <public-tips content="设置后,会在填制表单时显示单位"></public-tips>
          </span>
        </el-radio>
      </div>
    </div>
    <!-- 表尾合计 -->
    <div class="add-c-type-number-total">
      <div class="c-panel-tabView-title">表尾合计</div>
      <div>
        <el-checkbox v-model="form.isTotal">
          <div class="c-panel-check-labelWrapper">
            <span>是</span>
            <public-tips :content="totalTip"></public-tips>
          </div>
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
  import popoverTip from "@/components/publicTips/popoverTip.vue"
  import publicTips from "@/components/publicTips/toolTip.vue"
  export default {
    components:{
      popoverTip,publicTips
    },
    props:{
      isEdit:[Boolean]
    },
    data() {

      return {
		getId:"",
        numberTypeList:[],
        shouqiAll:true,  //是否显示自动计算计算器
        form:{
          valueType:"0",
          formula:"",
          decimalNum_s:false,
          unit:"",
          isTotal:false,
          decimalNum:"",
          unitType:"1",
          formulaName:"", // 规则框显示
        },
        totalTip:"选择后,会在列表末尾\"全部合计\"列中进行合计统计",
        rulesList:[           // 自动计算公式规则
        	{value: "+",id:1},
        	{value: "-",id:2},
        	{value: "*",id:3},
        	{value: "/",id:4},
        	{value: "(",id:5},
        	{value: ")",id:6},
        ],
      }
    },
    created() {
      this.getAllNuberType();
    },
    methods:{
      // 清空
      deleteAll() {
      	this.form.formulaName = '';
      	this.form.formula= '';
      },
      // 计算内容点击
      handleContentClick(i) {
          this.form.formulaName += "{"+i.name+"}";
          if(i.id==='3' ){
           this.form.formula += "this.allData.debitMoney";
          }else if( i.id === '4'){
           this.form.formula += "this.allData.creditorMoney";
          }else{
           this.form.formula += "this.allData.field_"+i.id;
          }

       },
      // 计算规则点击
      handleRuleC(i) {
      	this.form.formulaName += i.value;
      	this.form.formula += i.value;
      },
      // 获取所有数值类型
      getAllNuberType(id) {
		if(id) this.getId = id;
      	this.$http.post('custom/findNumTypeCoustom' , {id:id}).then(res=>{
      		if(res&&res.data.code==1) {
      			this.numberTypeList = res.data.data.map(i=>{
      				i.color=this.randomColor();
      				return i;
      			});
      		}
      	})
      },
      // 随机颜色函数
      randomColor(){
      	let r,g,b,a;
      	r = Math.floor(Math.random()*256);
      	g = Math.floor(Math.random()*256);
      	b = Math.floor(Math.random()*256);
      	a = 0.8;
      	return 'rgba(' + r +',' + g + ',' + b + ',' + a +")";
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-type-number.vue